import CheckboxGroup from "@/components/CheckboxGroup";
import usePlatform from "@/hooks/usePlatform";
import useThemeData from "@/hooks/useThemeData";
import { renderCabinsColor, renderProgramsLogo } from "@/utils/commonRender";

import { useFilterContext } from "../FilterContext";

const FilterItemPrograms = () => {
  const { filterData, setFilterData, filterOptions, filterOptionsCount, filterProgramsCabins } =
    useFilterContext();

  const { isDarkMode } = useThemeData();
  const { isMobile } = usePlatform();

  const renderCabins = (cabinType: string, programsCode: string) => {
    return (
      <div className="flex space-x-[10px] text-[13px]">
        <div className={isMobile ? "w-[45px]" : "w-[60px]"}>
          {renderCabinsColor(
            cabinType,
            filterProgramsCabins[programsCode]?.[cabinType]
              ? `${Math.ceil(filterProgramsCabins[programsCode][cabinType] / 100) / 10}K`
              : " - "
          )}
        </div>
      </div>
    );
  };
  return (
    <CheckboxGroup
      options={filterOptions.programsOptions.map((item) => ({
        ...item,
        label: (
          <div className="my-[5px]">
            <div>
              {`${item.label} (${filterOptionsCount["programs"][
                item.value
              ]?.progress.toLocaleString()}/${filterOptionsCount["programs"][
                item.value
              ]?.total.toLocaleString()})`}
            </div>
            <div className="flex space-x-[10px] text-[13px]">
              {renderCabins("Economy", item.value)}
              {renderCabins("PremiumEconomy", item.value)}
              {renderCabins("Business", item.value)}
              {renderCabins("First", item.value)}
            </div>
          </div>
        ),
      }))}
      value={
        filterData.programs.length > 0
          ? filterData.programs
          : filterOptions.programsOptions.map(({ value }) => value)
      }
      onChange={(value) => {
        setFilterData({
          programs: value.length === filterOptions.programsOptions.length ? [] : value,
        });
      }}
      renderPrefix={(params) => {
        return renderProgramsLogo(params.value, isDarkMode);
      }}
    />
  );
};

export default FilterItemPrograms;
